<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <v-card-title class="ma-0 pa-0">
          <v-row no-gutters align="" class="ma-0" justify="end">
            <v-col cols="12">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t("property.propertyType.title") }}
              </h3>
            </v-col>
            <v-col cols="5">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                :placeholder="$t('landlord.name')"
                class="mx-2 custom-label-color"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn class="ml-2" v-on="on" v-bind="attrs" icon>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="text-body-2">
                <v-list-item @click="showRightSideDrawer('PROPERTY_TYPE')">
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-plus-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("property.propertyType.btnTitle") }}
                  </v-list-item-text>
                </v-list-item>
                <v-list-item @click="exportData">
                  <v-list-item-icon>
                    <v-icon color="success"> mdi-application-export </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("common.excel") }}
                  </v-list-item-text>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
          </v-row>
        </v-card-title>
        <!-- <v-card-title class="ma-0 pa-0">
          <v-row class="ma-0">
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
            <v-text-field
              :label="$t('common.search')"
              v-model="search"
              class="mx-2"
              outlined
              dense>
            </v-text-field>
            <v-btn
              outlined
              @click="exportData"
              class="primary mx-2 white--text custom-button"
            >
              <v-icon small class="mx-2">
                mdi-application-export
              </v-icon>
              {{
                $t("common.excel")
              }}
            </v-btn>
          </v-row>
        </v-card-title> -->
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          id="propertyTypeTable"
          :headers="headers"
          :header-props="{ align: $vuetify.rtl ? 'right' : 'left' }"
          :items="propertyTypeLists"
          :search="search"
          :loading="loading"
          class="mt-3 mb-9 datatable"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalPropertyType"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  propertyTypeLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.rentType`]="{ item }">
            <v-chip class="green white--text" x-small v-if="item.rentType">
              {{ rentTypeText[item.rentType] }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-icon color="primary" @click="editPropertyType(item)"
                >mdi-pencil</v-icon
              >
              <v-icon color="red" @click="showDeleteDialog(item)"
                >mdi-delete</v-icon
              >
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { deletePropertyType } from "../methods/propertyType/delete_property_type";
export default {
  data() {
    return {
      loading: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      propertyTypeLists: [],
      totalPropertyType: 10
    };
  },
  computed: {
    rentTypeText() {
      return {
        PER_MONTH: "Monthly",
        PER_DAY: "Daily"
      };
    },
    headers() {
      return [
        {
          text: "#",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.en")})`,
          value: "nameEn",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.ar")})`,
          value: "nameAr",
          sortable: false,
          width: 100
        },
        //  {
        //   text: this.$t('property.unit.rentType'),
        //   value: "rentType",
        //   sortable: false,
        //   width: 100
        // },
        {
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
          width: 100
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  watch: {
    search(val) {
      this.loading = true;
      this.$apollo.queries.getPropertyTypes.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPropertyType,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: val
        }
      });
      this.loading = false;
    },
    options() {
      this.$apollo.queries.getPropertyTypes.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalPropertyType,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    }
  },
  apollo: {
    getPropertyTypes() {
      this.loading = true;
      return {
        query: require("@/property/api/queries/propertyType/property_type_query.graphql"),
        variables: {
          input: {
            limit: this.totalPropertyType,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.propertyTypeLists = this.$format.cloneVariable(
            data.getPropertyTypes.PropertyTypes
          );
          this.loading = loading;
          this.totalPropertyType = data.getPropertyTypes.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("deleteItems", data => {
      if (data.module === "propertype") {
        const input = data.item._id;
        deletePropertyType(input).then(data => {
          if (data.data.deletePropertyType) {
            this.$apollo.queries.getPropertyTypes.refetch({
              limit:
                this.options.itemsPerPage !== -1
                  ? this.options.itemsPerPage
                  : this.totalPropertyType,
              skip:
                this.options.page * this.options.itemsPerPage -
                this.options.itemsPerPage
            });
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.deleteSuccess"),
              color: "green"
            });
            this.$store.commit("DELETE_BTN_LOADING", false);
          }
        });
      }
    });
    this.$root.$on("propertyTypeTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchPropertyType", () => {
      this.$apollo.queries.getPropertyTypes.refetch({
        limit:
          this.options.itemsPerPage !== -1
            ? this.options.itemsPerPage
            : this.totalPropertyType,
        skip:
          this.options.page * this.options.itemsPerPage -
          this.options.itemsPerPage
      });
    });
    this.$root.$on("searchPropertyType", data => {
      this.search = data;
    });
    this.$root.$on("exportPropertyType", () => {
      this.exportData();
    });
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("PROPERTY_FORMNAME", item);
    },
    exportData() {
      this.$apollo.queries.getPropertyTypes
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(response => {
          this.options.itemsPerPage = response.data.getPropertyTypes.totalCount;
          this.propertyTypeLists = response.data.getPropertyTypes.PropertyTypes;
          setTimeout(() => {
            this.htmlToExcel("propertyTypeTable");
          }, 1000);
        });
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", {
        dialog: true,
        item: item,
        module: "propertype"
      });
    },
    editPropertyType(item) {
      this.$store.commit("EDIT_PROPERTY_TYPE", item);
      this.$store.commit("IS_EDIT_PROPERTY_TYPE", true);
      this.$store.commit("PROPERTY_FORMNAME", "PROPERTY_TYPE");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  beforeDestroy() {
    this.$root.$off("deleteItems");
    this.$root.$off("propertyTypeTable");
    this.$root.$off("refetchPropertyType");
    this.$root.$off("exportPropertyType");
    this.$root.$off("searchPropertyType");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
